import { Rating, styled } from "@mui/material";

function BaseRating({ value, icon, emptyIcon, color, size, readOnly }) {
    //styling the rating
    const StyledRating = styled(Rating)({
        "& .MuiRating-iconFilled": {
            color: color,
        },
    });

    //getting the icon and empty icon
    const Icon = icon;
    const EmptyIcon = emptyIcon;

    return (
        <StyledRating
            name="customized-color"
            defaultValue={value}
            getLabelText={value => `${value}`}
            icon={<Icon size={size} color={color} variant="Bold" />}
            emptyIcon={<EmptyIcon size={size} color="var(--gray-color)" />}
            dir="ltr"
            readOnly={readOnly}
        />
    );
}

export default BaseRating;
